import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.loadSavedTheme()
        this.setupSystemThemeListener()
    }

    loadSavedTheme() {
        const theme = localStorage.getItem('theme') || 'system'
        this.applyTheme(theme)
    }

    setupSystemThemeListener() {
        this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
        this.mediaQuery.addEventListener('change', (e) => {
            if (localStorage.getItem('theme') === 'system') {
                this.applySystemTheme()
            }
        })
    }

    applyTheme(theme) {
        localStorage.setItem('theme', theme)
        this.updateActiveTheme(theme)
        
        if (theme === 'system') {
            this.applySystemTheme()
        } else {
            if (theme === 'dark') {
                document.documentElement.classList.add('dark')
            } else {
                document.documentElement.classList.remove('dark')
            }
            this.updateIcons(theme)
        }
    }

    applySystemTheme() {
        const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches
        if (isDark) {
            document.documentElement.classList.add('dark')
        } else {
            document.documentElement.classList.remove('dark')
        }
        this.updateIcons(isDark ? 'dark' : 'light')
    }

    updateIcons(theme) {
        const icons = document.querySelectorAll('[data-theme-icon]')
        icons.forEach(icon => {
            if (icon.dataset.themeIcon === theme) {
                icon.classList.remove('hidden')
            } else {
                icon.classList.add('hidden')
            }
        })
    }

    updateActiveTheme(theme) {
        const buttons = document.querySelectorAll('[data-active-theme]')
        buttons.forEach(button => {
            button.dataset.active = button.dataset.themeParam === theme
        })
    }

    setTheme(event) {
        const theme = event.currentTarget.dataset.themeParam
        this.applyTheme(theme)
    }
}